import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerticalSplitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vertical_split"}/>
}
